import { makeStyles } from '@fluentui/react-components';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { slThemeLight } from '../slTheme';
import { SiteHeader } from './SiteHeader';
import { withStyles } from "./withStyles";

export type LabeledItemPosition = "above" | "below";

export class LabeledItemPositions
{
    static readonly Above = "above";
    static readonly Below = "below";
}

export interface LabeledItemProps
{
    styles: Record<string, string>;
    text: string;
    label: string;
    position: LabeledItemPosition;
    border?: boolean;
}

export interface LabeledItemState
{
}

const useStyles = makeStyles(
    {
        container:
        {
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        },
        label:
        {
            textTransform: 'lowercase',
            fontSize: slThemeLight.fontSizeBase200,
            lineHeight: slThemeLight.lineHeightBase200,
        },
        text:
        {
            fontSize: slThemeLight.fontSizeBase400,
            lineHeight: slThemeLight.lineHeightBase400,
//            borderBottom: '1pt  solid ' + slThemeLight.colorNeutralForeground1,
            paddingRight: '5pt',
        },
    });

export class LabeledItemWithoutStyles extends React.Component<LabeledItemProps, LabeledItemState>
{
    render()
    {
        return (
            <div className={this.props.styles.container }>
                {this.props.position === LabeledItemPositions.Above && <div className={this.props.styles.label}>{this.props.label}</div>}
                <div className={this.props.styles.text}>{this.props.text}</div>
                {this.props.position === LabeledItemPositions.Below && <div className={this.props.styles.label}>{this.props.label}</div>}
            </div>
        );
    }
}

export const LabeledItem = withStyles(useStyles, LabeledItemWithoutStyles);